<template>
    <div>
        <b-container fluid>
            <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />
            <b-row no-gutters class="mt-3 mb-3">
                <b-col style="text-align: right">
                    <b-button
                        v-if="
                            this.$route.params.user_id ?
                            ($store.state.user_obj &&
                            checkPermission(
                                $store.state.user_obj,
                                'Account',
                                'Permission Group',
                                'Edit',
                                true
                            )) :
                            ($store.state.user_obj &&
                            checkPermission(
                                $store.state.user_obj,
                                'Account',
                                'Permission Group',
                                'Create',
                                true
                            ))
                        "
                        size="sm"
                        class="btn-action"
                        variant="info"
                        @click="submitForm()"
                        >Save</b-button
                    >
                </b-col>
            </b-row>
            <b-card class="mb-1">
                <FormInput
                    :canEditFields="canEditFields"
                    :validateState="validateState"
                    :getErrorMessages="getErrorMessages"
                    :data="cms_permission_group_obj"
                    :onChangeData="onChangeData"
                />
            </b-card>

            <b-card class="mb-1">
                <b-table
                    responsive
                    small
                    outlined
                    striped
                    hover
                    :items="permissions"
                    :fields="permission_fields">
                    <template v-slot:head(enable)="data">
                        <a href="#" @click="selectAll">
                            SelectAll
                        </a>
                        /
                        <a href="#" @click="unselectAll">
                            UnselectAll
                        </a>
                    </template>
                    <template v-slot:cell(enable)="data">
                        <b-form-checkbox
                            size="sm"
                            value="1"
                            unchecked-value="0"
                            plain
                            v-model="permission_obj[`${data.item.id}`].enable"
                            @change="onChangeCheckbox($event, data.item.id)"
                        ></b-form-checkbox>
                    </template>
                </b-table>
            </b-card>

            <b-row no-gutters class="mt-3 mb-3">
                <b-col style="text-align: right">
                    <b-button
                        v-if="
                            this.$route.params.user_id ?
                            ($store.state.user_obj &&
                            checkPermission(
                                $store.state.user_obj,
                                'Account',
                                'Permission Group',
                                'Edit',
                                true
                            )) :
                            ($store.state.user_obj &&
                            checkPermission(
                                $store.state.user_obj,
                                'Account',
                                'Permission Group',
                                'Create',
                                true
                            ))
                        "
                        size="sm"
                        class="btn-action"
                        variant="info"
                        @click="submitForm()"
                        >Save</b-button
                    >
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
    required,
    requiredIf,
    minLength,
} from "vuelidate/lib/validators";
import FormInput from "./common/FormInput";
import global_function from "../mixins/global_function";

export default {
    name: "PermissionGroupForm",
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "ERROR_MESSAGES"],
    mixins: [validationMixin, global_function],
    components: {
        FormInput
    },
    data() {
        return {
            breadcrumb_items: [
                {
                    text: "Permission Group",
                    to: { name: "cms_permission_group" }
                },
                {
                    text: "Form",
                    active: true
                }
            ],

            loader: false,
            cms_permission_group_obj: {},
            permissions: [],
            permission_obj: {},
            client_options: [],
            permission_fields: [
                {
                    key: "module",
                    label: "Module"
                },
                {
                    key: "sub_module",
                    label: "Sub Module"
                },
                {
                    key: "sys_function",
                    label: "Function"
                },
                {
                    key: "enable",
                    label: "Enabled"
                }
            ],
        };
    },
    async created() {
        await this.getUserPermission();
        await this.getPermissionGroup();

        if (this.$route.params.user_id) {
            this.edit_mode = true;
        }
        this.initialized = true;
    },
    validations: {
        cms_permission_group_obj: {
            name: {
                required
            },
        },
    },
    computed: {
        canEditFields: function() {
            return [
                {
                    type: "text",
                    key: "name",
                    label: "* Name"
                },
            ]
        }
    },
    mounted() {},
    watch: {},
    methods: {
        async getPermissionGroup() {
            if (!this.$route.params.permission_group_id) {
                this.cms_permission_group_obj = {
                };
                return;
            }
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "cms_permission_group_get.php",
                data: {
                    permission_group_id: this.$route.params.permission_group_id,
                    account_type: this.$store.state.user_obj.account_type,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });

            this.cms_permission_group_obj = response.data.permission_groups[0];
            let permissions = response.data.permission_groups[0].permissions;
            permissions.forEach(p => {
                this.permission_obj[p.permission_id].enable = 1;
            })

            console.log(this.cms_permission_group_obj);
        },

        async getUserPermission() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "cms_permission_get.php",
                data: {
                }
            });

            this.permissions = response.data.permissions;
            this.permissions.forEach(p => {
                this.permission_obj[p.id] = p;
            });

            console.log(this.permission_obj);
        },

        validateState(name) {
            const { $dirty, $error } = this.$v.cms_permission_group_obj[name];
            return $dirty ? !$error : null;
        },

        getErrorMessages(key) {
            let validators = Object.keys(this.$v.cms_permission_group_obj[key].$params);
            let errors = validators
                .filter(v => this.$v.cms_permission_group_obj[key][v] === false)
                .map(v => this.ERROR_MESSAGES[v]);
            return errors;
        },

        async submitForm() {
            this.$v.cms_permission_group_obj.$touch();
            if (this.$v.cms_permission_group_obj.$anyError) {
                return;
            }

            let params = {
                cms_permission_group_obj: this.cms_permission_group_obj,
                user_id: this.$store.state.user_obj.user_id,
                client_id: this.$store.state.user_obj.client_id,
                permission_obj: this.permission_obj,
            };

            let req_url = "cms_permission_group_add.php";

            if (this.$route.params.permission_group_id) {
                params.permission_group_id = this.$route.params.permission_group_id;
                req_url = "cms_permission_group_edit.php";
            }

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: req_url,
                data: params
            });

            if (response.data.status === "fail") {
                this.$eventHub.$emit("show_modal_message", {
                    message_content: response.data.error,
                    variant: "danger"
                });
            } else {
                this.$eventHub.$emit("show_modal_message", {
                    message_content: "Update Permission Group Success"
                });

                this.$router.go(-1);
            }
        },
        onChangeData: function(data) {
            this.cms_permission_group_obj = data;
        },
        onChangeCheckbox: function(val, id) {
            this.permission_obj[`${id}`].enable = val;
        },
        selectAll: function(e) {
            e.preventDefault();
            console.log(this.permissions)
            for (const key in this.permission_obj) {
                let p = this.permissions;
                p.find(p => p.id === key).enable = 1;
                this.permissions = [...p];
                this.permission_obj[key].enable = 1;
            }
        },
        unselectAll: function(e) {
            e.preventDefault();
            for (const key in this.permission_obj) {
                let p = this.permissions;
                p.find(p => p.id === key).enable = 0;
                this.permissions = [...p];
                this.permission_obj[key].enable = 0;
            }
        },
    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}

.file_document {
    display: none;
}

.preview_img-product {
    max-width: 100%;
    max-height: 200px;
}

.container-preview_img {
    padding: 5px;
}

.icon-add_image {
    color: #cacaca;
}

.col-image {
    display: flex;
    justify-content: center;
    align-items: center;
}

.form-group {
    margin-bottom: 0;
    margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/CmsPermissionGroupForm.vue